/* Keep the complete gallery reachable on short laptop screens.
   CSS handles scrolling; measure only when gallery or viewport dimensions change. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.Prod-main .product__images > .product-gallery').forEach(gallery => {
      if (gallery.dataset.lsDesktopGallery) return;
      gallery.dataset.lsDesktopGallery = 'true';
      const update = () => {
        if (!gallery.isConnected) {
          observer?.disconnect();
          window.removeEventListener('resize', update);
          return;
        }
        const top = Math.min(100, window.innerHeight - gallery.getBoundingClientRect().height - 24);
        gallery.style.setProperty('--ls-gallery-sticky-top', `${Math.round(top)}px`);
      };
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
      observer?.observe(gallery);
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
